import { render, staticRenderFns } from "./groups_render.vue?vue&type=template&id=7ff63734&"
import script from "./groups_render.vue?vue&type=script&lang=js&"
export * from "./groups_render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff63734')) {
      api.createRecord('7ff63734', component.options)
    } else {
      api.reload('7ff63734', component.options)
    }
    module.hot.accept("./groups_render.vue?vue&type=template&id=7ff63734&", function () {
      api.rerender('7ff63734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/groups_render.vue"
export default component.exports